<template lang="pug">
.states
  .states__mobile
    .states__block
      .section-block.section-block-stroke(
        @click="filterShow = !filterShow"
        :class="{'section-block-open': filterShow}"
      )
        svg.section-block__icon
          use(xlink:href="#filter")

        .section-block__name(v-html="stateTitle")

        svg.section-block__arrow
          use(xlink:href="#arrow")

    .states__filter(
      :class="{'states__filter-open': filterShow}"
    )
      .states__input
        .input-search
          input.input-search__input(
            :placeholder="statePlaceholderInput"
            v-model="searchState"
            :class="{'input-search__input-active': searchState.length > 0}"
          )

          svg.input-search__icon
            use(xlink:href="#search")

      .states__list.states__list-mobile
        .states__item.states__item-active
          a.states__link(:href="stateActiveUrl" v-html="stateActiveName")

        .states__item(
          v-for="(state, index) of searchList.slice(0, countButtonShow)"
          :key="index"
          :class="{'states__item-green': (getState(state, 'name') === stateAllName) && (getState(state, 'url') === stateAllUrl)}"
        )
          a.states__link(:href="getState(state, 'url')" v-html="getState(state, 'name')")

      .states__show(
        v-show="searchList.slice(0, list.length).length > countButtonShowDefault"
      )
        .button-show
          .button-show__text(
            v-html="countButtonShowName"
            @click="changeButtonShow()"
          )

  .states__list.states__list-desk
    .states__item(
      v-for="(state, index) of list.slice(0, countView)"
      :key="index"
      :class="{'states__item-active': (getState(state, 'name') === stateActiveName) && (getState(state, 'url') === stateActiveUrl)}"
    )
      a.states__link(:href="getState(state, 'url')" v-html="getState(state, 'name')")

  .states__more(v-if="isButtonMore")
    .button-more(@click="changeButtonMore()")
      svg.button-more__icon
        use(xlink:href="#more")

      .button-more__text(v-html="stateButtonMoreName")

</template>

<script>
export default {
  name: 'AppStates',

  props: [
    'stateList',
    'stateAllName',
    'stateAllUrl',
    'stateActiveName',
    'stateActiveUrl',
    'stateCountView',
    'stateButtonMoreName',
    'stateTitle',
    'statePlaceholderInput',
    'stateButtonTextShow',
    'stateButtonTextHidden',
    'stateButtonTextCount'
  ],

  data () {
    return {
      list: [],
      countView: 0,
      isButtonMore: false,
      searchState: '',
      countButtonShowName: '',
      countButtonShow: 0,
      countButtonShowDefault: 0,
      filterShow: false
    }
  },

  computed: {
    searchList () {
      return this.list.filter(state => {
        let arrState = state.split('=')

        if ((arrState[0] === this.stateAllName) && (arrState[1] === this.stateAllUrl)) {
          return true
        } else {
          return arrState[0].toLowerCase().includes(this.searchState.toLowerCase())
        }
      })
    }
  },

  methods: {
    getState (state, type) {
      const result = state.split('=')

      if (type === 'name')
        return result[0]

      if (type === 'url')
        return result[1]

      return false
    },

    changeButtonMore () {
      this.countView = this.list.length
      this.isButtonMore = false
    },

    changeButtonShow () {
      if (this.countButtonShowName === this.stateButtonTextShow) {
        this.countButtonShowName = this.stateButtonTextHidden
        this.countButtonShow = this.list.length
      } else {
        this.countButtonShowName = this.stateButtonTextShow
        this.countButtonShow = this.countButtonShowDefault
      }
    }
  },

  created () {
    let curStateList = this.stateList
    curStateList = this.stateAllName + '=' + this.stateAllUrl + '|' + curStateList

    this.list = curStateList.split('|')
    this.countView = this.stateCountView
    this.isButtonMore = (this.list.length > this.countView)
    this.countButtonShowName = this.stateButtonTextShow
    this.countButtonShow = this.stateButtonTextCount
    this.countButtonShowDefault = this.stateButtonTextCount
  }
}
</script>
